import { _post, _get, _delete } from "./Axios";

export default class MenuApi {
  static get(id = null) {
    if (id == null) {
      return _get("masterdata/menu");
    } else {
      return _get("masterdata/menu/" + id);
    }
  }
  static getByKeyword(keyword = "") {
    return _get("masterdata/menu?keyword=" + keyword);
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("masterdata/menu?" + params);
  }
  static post(data) {
    return _post("masterdata/menu", data);
  }
  static update(id, data) {
    return _post("masterdata/menu/" + id, data);
  }
  static delete(id) {
    return _delete("masterdata/menu/" + id);
  }
}
